<svg width="12" height="12" version="1.1" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
 <path d="m6 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1 8h-2v-4h2zm0-5c-0.4714 0.4714-1.5286 0.4714-2 0s-0.4714-1.5286 0-2 1.5286-0.4714 2 0 0.4714 1.5286 0 2z" fill-rule="evenodd"/>
</svg>
